import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Grid, TextField, Box, Tooltip } from "@mui/material";
import { noShowBooking } from "../../../../redux/reducers/HotelPortalReducer";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { IRootState } from "src/redux/reducers/CombinedReducers";
import UndoIcon from "@mui/icons-material/Undo";
import cloneDeep from "lodash/cloneDeep";

interface INoShowProps {
  rowParams: any;
}

export default function NoShow(props: INoShowProps): JSX.Element {
  const { rowParams } = props;
  const dispatch = useDispatch();
  const hotelBookings: any = useSelector((state: IRootState) => state.hotelBookings.hotelBookings);
  const fetchingThunk = useSelector((state: IRootState) => state.hotelBookings.fetchingThunk);
  const handleNoShow = (noShow: string, temp_id: string, hotelId: string): void => {
    const bookingDetail = hotelBookings.find((booking: any) => {
      return booking.temp_id === temp_id;
    });
    if (bookingDetail) {
      const noShowBookingDetail = cloneDeep(bookingDetail);
      noShowBookingDetail.isNoShow = noShow;
      dispatch(
        noShowBooking({
          booking: noShowBookingDetail,
          hotelIDs: [hotelId],
        })
      );
    }
  };

  const disabledStatus = ["noChanges", "modifications", "removals"];
  return (
    <>
      {(rowParams.isNoShow === "false" || !rowParams.isNoShow) && (
        <Tooltip title="Mark As A No Show">
          <>
            <Button
              disabled={!disabledStatus.includes(rowParams.statusName) || fetchingThunk}
              color="error"
              onClick={() => handleNoShow("true", rowParams.temp_id, rowParams.hotel_id)}
            >
              <PersonSearchIcon sx={{ fontSize: "14px" }} />
            </Button>
          </>
        </Tooltip>
      )}
      {rowParams.isNoShow === "true" && (
        <Tooltip title="Remove No Show">
          <>
            <Button
              disabled={!disabledStatus.includes(rowParams.statusName) || fetchingThunk}
              sx={{ color: "white" }}
              variant="contained"
              color="error"
              size="small"
              onClick={() => handleNoShow("false", rowParams.temp_id, rowParams.hotel_id)}
            >
              <UndoIcon sx={{ fontSize: "14px" }} />
            </Button>
          </>
        </Tooltip>
      )}
    </>
  );
}
